import { Box, Typography, useMediaQuery } from "@mui/material"
import { theme } from "../../../utils/theme/godzilla_light"
import { Trans } from "react-i18next";
import { EDUCATION_HUB_CONTENT_MAX_WIDTH } from "../constants"

const styles = {
    rowBoxWrapper: {
        pt: "63px",
        pb: "27px",
        px: "31px",
        display: "flex",
        alignItems: 'center',
        justifyContent: "center",
        backgroundColor: "#F8F8F8"
    },
}
interface IPageSectionProps {
    title?: string;
    description?: string;
    sectionWrapperSx?: any;
    rightElement?: JSX.Element;
    containerBoxSx?: any;
    rowImageSource?: any;
    rowImageSx?: any;
    rightWrapperSx?: any;
    descriptionSx?: any;
    contentWrapperSx?:any;
    titleSx?: any;
}
const PageRowSection = (props: IPageSectionProps) => {
    const { title, description, sectionWrapperSx, rightElement = null, containerBoxSx, rowImageSource, rowImageSx, rightWrapperSx, descriptionSx, contentWrapperSx, titleSx } = props;
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))
    
    return (
        <Box sx={{ ...styles.rowBoxWrapper, ...sectionWrapperSx }} textAlign={isMobileX ? "center" : "left"}>
            <Box maxWidth={EDUCATION_HUB_CONTENT_MAX_WIDTH} width="100%" sx={{ display: "flex", flexWrap: "wrap", ...containerBoxSx }} gap={"57px"}>
                <Box sx={{ flex: isMobileX ? null : 1, ...contentWrapperSx }}>
                    <Typography sx={{ ...theme.typography.components.sectionTitle, ...titleSx }}>
                        {title}
                    </Typography>
                    {description ?
                        <Typography sx={{ ...theme.typography.components.sectionDescription, mt: "24px", ...descriptionSx }}>
                            <Trans
                                i18nKey={description}
                                components={{ br: <br />, sup: <sup /> }} />
                        </Typography>
                        : null}
                </Box>
                <Box sx={{ flex: isMobileX ? null:1, ...rightWrapperSx }}>
                    {rightElement}
                    {rowImageSource ?
                        <img src={rowImageSource} style={{ maxWidth: "529px", height: "194px", ...rowImageSx }} alt={rowImageSource} />
                        : null}
                </Box>
            </Box>
        </Box>
    )
}

export default PageRowSection